import { useRef } from "react";

export const useAnalyticsTrackingState = () => {
  const ref = useRef<
    {
      id: string;
      event: string;
    }[]
  >([]);

  return ref.current;
};
